import React from 'react';
import { ItemRenderer } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { FormTemplateOption } from 'data/template/template.types';
import { highlightText } from './advancedSelect.utils';

const advancedSelectItemRenderer: ItemRenderer<FormTemplateOption> = (item, { handleClick, modifiers, query }) => {
  if (!modifiers.matchesPredicate) {
    return null;
  }

  const text = item.label;
  return (
    <MenuItem
      active={modifiers.active}
      disabled={modifiers.disabled}
      key={item.value}
      onClick={handleClick}
      text={highlightText(text, query)}
    />
  );
};

export default advancedSelectItemRenderer;
